"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect, useMemo, useRef, useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useIdentity } from "../../../hooks/useIdentity";
import { useAuth } from "../../auth/Auth";
import { useSeizeConnectContext } from "../../auth/SeizeConnectContext";
import HeaderShare from "../../header/share/HeaderShare";
import WebSidebarHeader from "./WebSidebarHeader";
import WebSidebarNav from "./WebSidebarNav";
import WebSidebarNavItem from "./nav/WebSidebarNavItem";
import WebSidebarUser from "./WebSidebarUser";
import { UserIcon } from "@heroicons/react/24/outline";
interface WebSidebarProps {
  readonly isCollapsed: boolean;
  readonly onToggle: () => void;
  readonly isMobile: boolean;
  readonly isNarrow?: boolean | undefined;
  readonly isOffcanvasOpen: boolean;
  readonly onCloseOffcanvas: () => void;
  readonly sidebarWidth: string;
}
function WebSidebar(t0) {
  const $ = _c(62);
  const {
    isCollapsed,
    onToggle,
    isMobile,
    isNarrow: t1,
    isOffcanvasOpen,
    onCloseOffcanvas,
    sidebarWidth
  } = t0;
  const isNarrow = t1 === undefined ? false : t1;
  const navRef = useRef(null);
  const pathname = usePathname();
  const {
    address
  } = useSeizeConnectContext();
  const {
    connectedProfile
  } = useAuth();
  const t2 = address || "";
  let t3;
  if ($[0] !== t2) {
    t3 = {
      handleOrWallet: t2,
      initialProfile: null
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    profile
  } = useIdentity(t3);
  connectedProfile?.handle;
  let t4;
  bb0: {
    if (connectedProfile?.handle) {
      t4 = `/${connectedProfile.handle}`;
      break bb0;
    }
    if (address) {
      t4 = `/${address}`;
      break bb0;
    }
    t4 = null;
  }
  const profilePath = t4;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const {
        window: browserWindow
      } = globalThis as typeof globalThis & {
        window?: Window | undefined;
      };
      if (browserWindow === undefined || typeof browserWindow.matchMedia !== "function") {
        setIsTouchScreen(false);
        return;
      }
      const coarsePointerQuery = browserWindow.matchMedia("(pointer: coarse)");
      const handlePointerChange = event => {
        setIsTouchScreen(event.matches);
      };
      setIsTouchScreen(coarsePointerQuery.matches);
      if (typeof coarsePointerQuery.addEventListener === "function") {
        coarsePointerQuery.addEventListener("change", handlePointerChange);
        return () => coarsePointerQuery.removeEventListener("change", handlePointerChange);
      }
      if ("onchange" in coarsePointerQuery) {
        const originalHandler = coarsePointerQuery.onchange;
        coarsePointerQuery.onchange = handlePointerChange;
        return () => {
          if (coarsePointerQuery.onchange === handlePointerChange) {
            coarsePointerQuery.onchange = originalHandler ?? null;
          }
        };
      }
    };
    t6 = [];
    $[2] = t5;
    $[3] = t6;
  } else {
    t5 = $[2];
    t6 = $[3];
  }
  useEffect(t5, t6);
  const prevPathnameRef = useRef(pathname);
  const isOverlayActive = isOffcanvasOpen && (isMobile || isNarrow);
  let t7;
  let t8;
  if ($[4] !== isMobile || $[5] !== isOffcanvasOpen || $[6] !== isOverlayActive || $[7] !== onCloseOffcanvas || $[8] !== pathname) {
    t7 = () => {
      if (prevPathnameRef.current !== pathname) {
        prevPathnameRef.current = pathname;
        if ((isMobile || isOverlayActive) && isOffcanvasOpen) {
          onCloseOffcanvas();
        }
      }
    };
    t8 = [pathname, isMobile, isOverlayActive, isOffcanvasOpen, onCloseOffcanvas];
    $[4] = isMobile;
    $[5] = isOffcanvasOpen;
    $[6] = isOverlayActive;
    $[7] = onCloseOffcanvas;
    $[8] = pathname;
    $[9] = t7;
    $[10] = t8;
  } else {
    t7 = $[9];
    t8 = $[10];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[11] !== isMobile || $[12] !== isOffcanvasOpen || $[13] !== isOverlayActive || $[14] !== onCloseOffcanvas) {
    t9 = () => {
      if (!isMobile && !isOverlayActive || !isOffcanvasOpen) {
        return;
      }
      const {
        window: browserWindow_0
      } = globalThis as typeof globalThis & {
        window?: Window | undefined;
      };
      if (browserWindow_0 === undefined) {
        return;
      }
      const handleEscapeKey = e => {
        if (e.key === "Escape") {
          onCloseOffcanvas();
        }
      };
      browserWindow_0.addEventListener("keydown", handleEscapeKey);
      return () => browserWindow_0.removeEventListener("keydown", handleEscapeKey);
    };
    t10 = [isMobile, isOffcanvasOpen, isOverlayActive, onCloseOffcanvas];
    $[11] = isMobile;
    $[12] = isOffcanvasOpen;
    $[13] = isOverlayActive;
    $[14] = onCloseOffcanvas;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  useEffect(t9, t10);
  const shouldShowCollapsed = isMobile && isOffcanvasOpen ? false : isCollapsed;
  const scrollContainerRef = useRef(null);
  let t11;
  if ($[17] !== onToggle) {
    t11 = () => {
      navRef.current?.closeSubmenu();
      onToggle();
    };
    $[17] = onToggle;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const handleToggle = t11;
  const shouldRenderSidebar = !isMobile || isOffcanvasOpen;
  if (!shouldRenderSidebar) {
    return null;
  }
  let t12;
  if ($[19] !== isMobile || $[20] !== isOverlayActive || $[21] !== onCloseOffcanvas) {
    t12 = isOverlayActive && <button type="button" className={isMobile ? "tw-fixed tw-inset-0 tw-z-[70] tw-border-0 tw-bg-gray-600 tw-bg-opacity-50 focus:tw-outline-none" : "tw-fixed tw-inset-0 tw-z-30 tw-border-0 tw-bg-gray-600 tw-bg-opacity-50 focus:tw-outline-none"} onClick={onCloseOffcanvas} aria-label="Close menu overlay" />;
    $[19] = isMobile;
    $[20] = isOverlayActive;
    $[21] = onCloseOffcanvas;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = isMobile ? "tw-fixed tw-inset-y-0 tw-left-0 tw-z-[80] focus:tw-outline-none" : "tw-fixed tw-inset-y-0 tw-left-0 tw-z-40 focus:tw-outline-none";
  let t14;
  if ($[23] !== isMobile) {
    t14 = isMobile ? undefined : {
      left: "var(--layout-margin, 0px)"
    };
    $[23] = isMobile;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== sidebarWidth) {
    t15 = {
      width: sidebarWidth
    };
    $[25] = sidebarWidth;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== handleToggle || $[28] !== shouldShowCollapsed) {
    t16 = <WebSidebarHeader collapsed={shouldShowCollapsed} onToggle={handleToggle} />;
    $[27] = handleToggle;
    $[28] = shouldShowCollapsed;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== shouldShowCollapsed) {
    t17 = <div className="tw-flex-1"><WebSidebarNav ref={navRef} isCollapsed={shouldShowCollapsed} /></div>;
    $[30] = shouldShowCollapsed;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== pathname || $[33] !== profilePath || $[34] !== shouldShowCollapsed) {
    t18 = profilePath && <div className="tw-px-3 tw-pt-2"><WebSidebarNavItem href={profilePath} icon={UserIcon} iconSizeClass="tw-h-6 tw-w-6" active={pathname === profilePath} collapsed={shouldShowCollapsed} label="Profile" /></div>;
    $[32] = pathname;
    $[33] = profilePath;
    $[34] = shouldShowCollapsed;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== shouldShowCollapsed) {
    t19 = <HeaderShare isCollapsed={shouldShowCollapsed} />;
    $[36] = shouldShowCollapsed;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== profile || $[39] !== shouldShowCollapsed) {
    t20 = <WebSidebarUser isCollapsed={shouldShowCollapsed} profile={profile} />;
    $[38] = profile;
    $[39] = shouldShowCollapsed;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t17 || $[42] !== t18 || $[43] !== t19 || $[44] !== t20) {
    t21 = <div className="no-scrollbar tw-flex tw-h-full tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300" data-sidebar-scroll="true">{t17}{t18}{t19}{t20}</div>;
    $[41] = t17;
    $[42] = t18;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t16 || $[47] !== t21) {
    t22 = <div className="tw-flex tw-h-full tw-flex-col tw-pt-2">{t16}{t21}</div>;
    $[46] = t16;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t15 || $[50] !== t22) {
    t23 = <div className="tw-group tw-relative tw-z-50 tw-h-full tw-border-0 tw-border-y-0 tw-border-l-0 tw-border-r tw-border-solid tw-border-iron-800 tw-bg-black tw-transition-[width] tw-duration-300 tw-ease-in-out focus:tw-outline-none" style={t15} aria-label="Primary sidebar" ref={scrollContainerRef}>{t22}</div>;
    $[49] = t15;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t13 || $[53] !== t14 || $[54] !== t23) {
    t24 = <div className={t13} style={t14}>{t23}</div>;
    $[52] = t13;
    $[53] = t14;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== isTouchScreen) {
    t25 = !isTouchScreen && <ReactTooltip id="sidebar-tooltip" place="right" offset={16} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 9999,
      pointerEvents: "none"
    }} border="1px solid #4C4C55" />;
    $[56] = isTouchScreen;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t12 || $[59] !== t24 || $[60] !== t25) {
    t26 = <>{t12}{t24}{t25}</>;
    $[58] = t12;
    $[59] = t24;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  return t26;
}
export default WebSidebar;